import { render } from "./ExistingLeads.vue?vue&type=template&id=288e24e4&scoped=true&ts=true"
import script from "./ExistingLeads.vue?vue&type=script&lang=ts"
export * from "./ExistingLeads.vue?vue&type=script&lang=ts"

import "./ExistingLeads.vue?vue&type=style&index=0&id=288e24e4&scoped=true&lang=css"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288e24e4"]])

export default __exports__